import { VisitNodePassage } from "../../../types";
import { getDateString } from "common/date-utils";
import { getLeafValue } from "hooks/widget-data/datapoints-api/helper";
import { language } from "language/default";
const init = (context) => {
    const { sparkline, variationOfMetric } = context.componentProps;
    const item = { value: {} };
    if (sparkline) {
        item.history = [];
        item.future = [];
    }
    if (variationOfMetric) {
        item.variation = {};
    }
    context.staticData.customResult = [item];
};
const setHistoryItem = (item, measures, params, future) => {
    const series = future ? item.future : item.history;
    if (series && measures.measures?.[params.name]) {
        series.push({
            custom: {
                tooltip: [
                    [language.en.chart.timeBasedSeries.tooltip.referenceDate, getDateString(measures.date)],
                    [params.label, getLeafValue(measures.measures[params.display])]
                ]
            },
            x: measures.dimension,
            y: getLeafValue(measures.measures[params.name])
        });
    }
};
const linkPastAndFuture = (history, future) => {
    if (history?.length && future?.length) {
        const overlapIndex = history.findIndex((point) => point.x && future[0].x && point.x >= future[0].x);
        if (overlapIndex >= 0) {
            history.splice(overlapIndex);
        }
        future.unshift({ ...history[history.length - 1] });
    }
};
const setItem = (args, params, main = true, future = false) => {
    const [item] = args.context.staticData.customResult, element = args.visitable;
    if (main && !item.value.formattedValue && element.measures?.[params.name]) {
        if (item.variation) {
            const display = element.measures[params.display], variation = element.measures[params.name];
            const previous = getLeafValue(variation.previousValue), value = getLeafValue(variation.currentValue);
            item.value = { formattedValue: display.currentValue, value };
            item.variation = {
                change: variation.change,
                current: item.value,
                percentChange: variation.changePercent,
                previous: { formattedValue: display.previousValue, value: previous }
            };
        }
        else {
            const value = getLeafValue(element.measures[params.name]);
            item.value = { formattedValue: element.measures[params.display], value };
        }
    }
    setHistoryItem(item, element || {}, params, future);
};
const sortAndGetLast = (items) => {
    if (items?.length) {
        items.sort((a, b) => (a.x ?? 0) - (b.x ?? 0));
        return items[items.length - 1];
    }
    return {};
};
const terminate = (args, params) => {
    const [item] = args.context.staticData.customResult, element = args.visitable;
    if (params.additionalDataSource) {
        const value = element.additionalData?.[params.additionalDataSource];
        item.value = { formattedValue: value?.toString(), value };
    }
    // In order to avoid glitches in the graph, points have to be sorted by the X axis value
    const lastHistory = sortAndGetLast(item?.history);
    const lastFuture = sortAndGetLast(item?.future);
    const lastItem = lastFuture.x ? lastFuture : lastHistory;
    linkPastAndFuture(item?.history, item?.future);
    lastItem.marker = { enabled: true, radius: 4 };
};
export const kpi = (params, fparams) => (args) => {
    if (!args.context.staticData.customResult) {
        init(args.context);
    }
    if (args.context.visitNodePassage === VisitNodePassage.Leaf && args.context.staticData.customResult) {
        setItem(args, params, !fparams);
        if (fparams) {
            setItem(args, fparams, true, true);
        }
    }
    if (args.context.visitNodePassage === VisitNodePassage.NodeLast && args.context.staticData.customResult) {
        terminate(args, params);
    }
};
